module.exports = __webpack_public_path__ + "static/media/antigua-beaches-16.dd0e55aa.jpg";